/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

export const getEntitySchema = (all, name) => {
    if (!all) {
        return null;
    }
    if (!name) {
        return null;
    }
    const schema = all[name];
    return schema;
};
